module.exports = "<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"error-template\">\n                <h1>\n                    Oops!</h1>\n                <h2>\n                    500 Internal Server Error</h2>\n                <div class=\"error-details\">\n                    Sorry, an error has occured.\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/error.component.html
// module id = 297
// module chunks = 1